<template>
  <section class="faq">
    <form v-if="filters && filters.length" class="faq__filter-form">
      <!-- Large Screen Filters  -->
      <!-- <div class="hidden lg:block space-y-7">
        <RadioInput
          v-for="filter of filters"
          :id="filter.id.toString()"
          :key="'filter-' + filter.id"
          v-model="selectedFilter"
          :label="filter.title"
          name="faq-filters"
          :value="filter.id"
        />
      </div> -->

      <!-- Smaller Screen Filters  -->
      <div>
        <BulletsSlider
          v-slot="{ item }"
          :items="filters"
          :selected-item="getSelectedItem()"
          type="secondary"
          class="flex-1 mt-2"
          :mobile-screen-attributes="{
            slidesPerView: 'auto',
          }"
          :large-screen-attributes="{
            slidesPerView: 'auto',
          }"
        >
          <div class="faq__control" :class="{ 'faq__control--checked': selectedFilter === +item.id }">
            <label class="faq__control-label block cursor-pointer" :for="item.id">{{ item.title }}</label>
            <input
              :id="item.id"
              v-model="selectedFilter"
              class="hidden"
              name="faq-filters-sm"
              type="radio"
              :value="item.id"
            />
          </div>
        </BulletsSlider>
      </div>
    </form>
  </section>
</template>

<script setup lang="ts">
import type { FaqCategory } from '@robustastudio/e-commerce/common';

const props = defineProps({
  categories: {
    type: Array as PropType<Array<FaqCategory>>,
    default: () => [],
  },
  filterBy: {
    type: Number,
    required: true,
  },
  fetching: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'filter', faq: FaqCategory | undefined): void;
}>();

const selectedFilter = ref(0);
const { t } = useI18n({
  useScope: 'local',
});
const filters = ref<FaqCategory[]>([
  {
    id: 0,
    title: t('allTopics'),
    slug: 'all-topics',
  },
]);

watch(
  () => props.categories,
  (newValue: FaqCategory[]) => {
    if (!newValue) return;
    filters.value = [...filters.value, ...newValue];
  },
  { immediate: true },
);

watch([selectedFilter], () => {
  emit(
    'filter',
    selectedFilter.value === 0
      ? undefined
      : filters.value.find(filter => {
          return +filter.id === +selectedFilter.value;
        }),
  );
});

function getSelectedItem() {
  return filters.value?.find(filter => {
    return +filter.id === +selectedFilter.value;
  });
}
</script>

<style lang="postcss">
.faq {
  border-radius: 40px;
}

.faq__control {
  @apply px-5 py-2 border text-sm whitespace-nowrap bg-white text-primary-1-100 border-primary-1-15 cursor-pointer;

  &--checked {
    @apply bg-primary-1-100 text-white font-bold border-primary-1-100;
  }
}
</style>

<i18n>
  {
    "en": {
      "filterBy": "Filter By Topic",
      "allTopics": "All Topics",
      "home": "Home",
      "faq": "FAQ"
    },
    "ar": {
      "filterBy": "تصنيف حسب",
      "allTopics": "جميع الموضوعات"
    }
  }
</i18n>
